/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_ConnectionsInputs */

const cs_settings_profile_connections = /** @type {(inputs: Settings_Profile_ConnectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaše napojení`)
};

const en_settings_profile_connections = /** @type {(inputs: Settings_Profile_ConnectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your connections`)
};

/**
* | output |
* | --- |
* | "Your connections" |
*
* @param {Settings_Profile_ConnectionsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_connections = /** @type {((inputs?: Settings_Profile_ConnectionsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_ConnectionsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_connections(inputs)
	return cs_settings_profile_connections(inputs)
});